// extracted by mini-css-extract-plugin
export default {"row":"SwitchVariantsParametersStyles_row__ltISZ","rowWithTextarea":"SwitchVariantsParametersStyles_rowWithTextarea__qCfpZ"};